import React, { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import '../styles/Transparency.css';
import environment from '../config/environment';

// --- SVG Icon Components for a more sophisticated look ---
const IconShield = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.286zm0 13.036h.008v.008h-.008v-.008z" />
  </svg>
);

const IconDocument = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
  </svg>
);

const IconChart = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6" />
  </svg>
);

const IconCheck = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
  </svg>
);

const IconFolder = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 9.75h16.5m-16.5 0A2.25 2.25 0 015.25 7.5h13.5a2.25 2.25 0 012.25 2.25m-16.5 0v6.75a2.25 2.25 0 002.25 2.25h13.5a2.25 2.25 0 002.25-2.25V9.75" />
  </svg>
);

const IconTrendingUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-3.75-.625m3.75.625V3.375" />
  </svg>
);

const IconPencil = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
  </svg>
);

const IconCalendar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0h18M-4.5 12h22.5" />
  </svg>
);

const IconBuilding = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z" />
  </svg>
);

const Transparency = () => {
  const { apiUrl } = environment();

  const [projectCount, setProjectCount] = useState(0);
  const [fundsRaised] = useState(0);

  useEffect(() => {
    const fetchPublicCauseCount = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/salesforce-public-causes`, {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Failed to load public causes (${response.status})`);
        }

        const payload = await response.json();
        const causes = Array.isArray(payload?.data?.causes) ? payload.data.causes : [];
        setProjectCount(causes.length);
      } catch (error) {
        console.error('Transparency page could not load Salesforce public cause count:', error);
        setProjectCount(0);
      }
    };

    fetchPublicCauseCount();
  }, [apiUrl]);

  const milestones = useMemo(
    () => [
      {
        id: 'step1',
        title: 'Foundation & 501(c)(3) Status',
        description: 'Secured federal tax-exempt status from the IRS.',
        complete: true,
        completeIcon: <IconCheck />,
        incompleteIcon: <IconShield />
      },
      {
        id: 'step2',
        title: 'Filed Initial 990-N',
        description: 'Submitted our first annual e-Postcard confirming good standing.',
        complete: true,
        completeIcon: <IconCheck />,
        incompleteIcon: <IconDocument />
      },
      {
        id: 'step3',
        title: 'Onboard First Projects',
        description: 'Opening sponsorship for our inaugural cohort of community-led initiatives.',
        complete: projectCount > 0,
        completeIcon: <IconCheck />,
        incompleteIcon: <IconFolder />
      },
      {
        id: 'step4',
        title: 'Publish First Impact Report',
        description: 'Share funds raised, programs supported, and communities reached.',
        complete: false,
        completeIcon: <IconCheck />,
        incompleteIcon: <IconTrendingUp />
      },
      {
        id: 'step5',
        title: 'Independent Audit',
        description: 'Engage a third-party CPA firm for a full financial audit.',
        complete: false,
        completeIcon: <IconCheck />,
        incompleteIcon: <IconPencil />
      }
    ],
    [projectCount]
  );

  useEffect(() => {
    const animateCounter = (el) => {
      const target = parseInt(el.dataset.target || '0', 10);
      const prefix = el.dataset.prefix || '';
      const duration = 1200;
      const start = performance.now();

      const tick = (now) => {
        const p = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - p, 3);
        const current = Math.round(target * eased);
        el.textContent = prefix + current.toLocaleString();
        if (p < 1) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
    };

    const animatedEls = document.querySelectorAll('.animated');
    const roadmapItems = document.querySelectorAll('.roadmap-item');
    const counters = document.querySelectorAll('.counter');

    counters.forEach((counter) => {
      counter.dataset.counted = '';
      const prefix = counter.dataset.prefix || '';
      counter.textContent = `${prefix}0`;
    });

    const animationObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');

            const counter = entry.target.querySelector('.counter');
            if (counter && !counter.dataset.counted) {
              animateCounter(counter);
              counter.dataset.counted = 'true';
            }
          }
        });
      },
      { threshold: 0.12 }
    );

    animatedEls.forEach((el) => animationObserver.observe(el));

    const roadmapObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute('id');
          const correspondingNavItem = document.querySelector(`.roadmap-item[data-step="${id}"]`);

          if (correspondingNavItem) {
            if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
              correspondingNavItem.classList.add('is-active');
            } else {
              correspondingNavItem.classList.remove('is-active');
            }
          }
        });
      },
      { rootMargin: '-40% 0px -50% 0px', threshold: 0.5 }
    );

    roadmapItems.forEach((item) => roadmapObserver.observe(item));

    return () => {
      animatedEls.forEach((el) => animationObserver.unobserve(el));
      roadmapItems.forEach((item) => roadmapObserver.unobserve(item));
      animationObserver.disconnect();
      roadmapObserver.disconnect();
    };
  }, [projectCount, fundsRaised]);

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'NGO',
    name: 'Cause & Impact, Inc.',
    url: 'https://causeandimpact.org/',
    email: 'mailto:compliance@causeandimpact.org',
    areaServed: 'US',
    foundingDate: '2024',
    identifier: [{ '@type': 'PropertyValue', propertyID: 'EIN', value: '33-4823180' }],
    sameAs: [
      'https://apps.irs.gov/app/eos/',
      'https://app.candid.org/profile/16361592/cause-and-impact-inc-33-4823180'
    ]
  };

  return (
    <div className="transparency-page-container">
      <Helmet>
        <title>Financial Transparency & Governance | Cause & Impact</title>
        <meta
          name="description"
          content="Explore Cause & Impact's Trust Center. View our IRS filings, governance documents, operational roadmap, and verify our 501(c)(3) public charity status."
        />
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>

      <main id="content" aria-labelledby="page-title">
        <header className="section hero" role="banner">
          <div className="wrap">
            <h1 id="page-title" className="animated" style={{ '--delay': '.1s' }}>
              Building Trust Through Transparency
            </h1>
            <p className="lede animated" style={{ '--delay': '.2s' }}>
              We believe financial clarity is the foundation of partnership. Here, we publish what we file,
              explain our journey, and provide the tools to verify our commitment—so you can support our projects with confidence.
            </p>
            <p className="last-updated">
              Last updated: <time dateTime="2025-09-04">September 4, 2025</time>
            </p>
          </div>
        </header>

        <section className="section" id="commitment" aria-labelledby="commitment-title">
          <div className="wrap">
            <h2 id="commitment-title" className="center animated">
              Our Commitment
            </h2>
            <div className="value-grid" role="list">
              <article className="value-card animated" role="listitem" style={{ '--delay': '.1s' }}>
                <div className="icon">
                  <IconShield />
                </div>
                <h3>Rock-Solid Compliance</h3>
                <p>
                  We meet all IRS requirements and adhere to best practices in nonprofit governance to protect our organization and the projects we serve.
                </p>
              </article>
              <article className="value-card animated" role="listitem" style={{ '--delay': '.2s' }}>
                <div className="icon">
                  <IconDocument />
                </div>
                <h3>Open Documentation</h3>
                <p>
                  What we file is available to the public. We provide direct access to our filings and clear context on what they mean for our mission.
                </p>
              </article>
              <article className="value-card animated" role="listitem" style={{ '--delay': '.3s' }}>
                <div className="icon">
                  <IconChart />
                </div>
                <h3>Proactive Reporting</h3>
                <p>
                  As we grow, our financial reporting will evolve. We are committed to publishing comprehensive financials and audits as we scale our impact.
                </p>
              </article>
            </div>
          </div>
        </section>

        <section className="section" id="filing" aria-labelledby="filing-title">
          <div className="wrap animated">
            <div className="filing-panel">
              <h2 id="filing-title" className="center">
                Our 2024 IRS Filing: Form 990-N
              </h2>
              <p className="center">
                As a new 501(c)(3) public charity with gross receipts under $50,000, we file the Form 990-N (e-Postcard).
                This filing affirms our good standing with the IRS. As our revenue and programs expand, we will graduate to
                more detailed forms (990-EZ or the full 990) to provide deeper financial insight.
              </p>
              <div className="center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '.5rem' }}>
                <a
                  className="btn"
                  href="https://causeandimpact-assets.s3.us-east-1.amazonaws.com/Financials/Cause+%26+Impact+IRS+Form+990+for+FY-2024+(990-N)+FILED.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Download the 2024 Form 990-N PDF"
                >
                  View 2024 Form 990-N (PDF)
                </a>
                <div className="caption">EIN: 33-4823180</div>
              </div>
            </div>
          </div>
        </section>

        <section className="section" id="roadmap" aria-labelledby="roadmap-title">
          <div className="wrap grid-2">
            <div>
              <h2 id="roadmap-title" className="animated">
                Our Roadmap to Impact
              </h2>
              <p className="animated" style={{ '--delay': '0.1s' }}>
                We’ve built the foundation, and now we’re focused on growth. This roadmap highlights our journey from incorporation to active sponsorship as you scroll.
              </p>
              <ol className="roadmap" role="list">
                {milestones.map((item) => (
                  <li
                    key={item.id}
                    id={item.id}
                    data-step={item.id}
                    className={`roadmap-item${item.complete ? ' is-complete' : ''}`}
                  >
                    <div className="dot">{item.complete ? item.completeIcon : item.incompleteIcon}</div>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </li>
                ))}
              </ol>
            </div>

            <div className="roadmap-sticky-panel">
              <aside className="dashboard-card animated" style={{ '--delay': '.2s' }}>
                <h3>Live Dashboard</h3>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem' }}>
                  Real-time data will populate as our programs launch.
                </p>
                <div className="dashboard-grid">
                  <div className="stat-item">
                    <div className="stat-label">Projects Supported</div>
                    <div className="stat-value counter" data-target={projectCount}>
                      {projectCount}
                    </div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-label">Total Funds Raised</div>
                    <div className="stat-value counter" data-target={fundsRaised} data-prefix="$">
                      ${fundsRaised}
                    </div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-label">IRS Filing Status</div>
                    <div className="stat-value compliant">Compliant</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-label">Next Filing Due</div>
                    <div className="stat-value">May 15, 2026</div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </section>

        <section className="section" id="filing-calendar" aria-labelledby="filing-calendar-title">
          <div className="wrap">
            <h2 id="filing-calendar-title" className="center animated">
              Filing Calendar
            </h2>
            <div className="document-grid" style={{ marginTop: '1rem' }}>
              <div className="doc-card animated" role="article" aria-label="Annual IRS e-Postcard" style={{ '--delay': '.1s' }}>
                <div className="doc-icon">
                  <IconCalendar />
                </div>
                <div className="doc-text">
                  <h3>Annual IRS e-Postcard (Form 990-N)</h3>
                  <p>Due each year by the 15th day of the 5th month after fiscal year end (calendar year: May 15).</p>
                </div>
              </div>
              <div className="doc-card animated" role="article" aria-label="State filings" style={{ '--delay': '.2s' }}>
                <div className="doc-icon">
                  <IconBuilding />
                </div>
                <div className="doc-text">
                  <h3>State Filings (as applicable)</h3>
                  <p>We will publish state charitable registrations/disclosures here as our fundraising footprint expands.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section" id="transparency-note" aria-labelledby="transparency-title">
          <div className="wrap animated">
            <h2 id="transparency-title" className="center">
              Technology Transparency
            </h2>
            <p className="center" style={{ maxWidth: '760px', margin: '0 auto' }}>
              Cause &amp; Impact operates on PhilOS and its AI compliance engine, technologies owned by Just Ask Phil, Inc., a separate for-profit company.
              We license these tools to better serve our fiscally sponsored projects. We do not sell or promote these services; this disclosure is provided for transparency and governance.
            </p>
          </div>
        </section>

        <section className="section" id="library" aria-labelledby="library-title">
          <div className="wrap">
            <h2 id="library-title" className="center animated">
              Public Records Library
            </h2>
            <p className="center animated" style={{ maxWidth: '760px', margin: '0 auto 2rem', '--delay': '.1s' }}>
              Key documents that outline our governance, policies, and legal standing.
            </p>
            <div className="document-grid">
              <a href="/docs/IRS-Determination-Letter.pdf" className="doc-card animated" style={{ '--delay': '.1s' }} target="_blank" rel="noopener noreferrer">
                <div className="doc-icon">
                  <IconDocument />
                </div>
                <div className="doc-text">
                  <h3>IRS Determination Letter</h3>
                  <p>Official 501(c)(3) proof</p>
                </div>
                <div className="doc-arrow" aria-hidden="true">→</div>
              </a>
              <a href="/docs/Bylaws.pdf" className="doc-card animated" style={{ '--delay': '.2s' }} target="_blank" rel="noopener noreferrer">
                <div className="doc-icon">
                  <IconDocument />
                </div>
                <div className="doc-text">
                  <h3>Organizational Bylaws</h3>
                  <p>Our rules of governance</p>
                </div>
                <div className="doc-arrow" aria-hidden="true">→</div>
              </a>
              <a href="/docs/Conflict-of-Interest-Policy.pdf" className="doc-card animated" style={{ '--delay': '.3s' }} target="_blank" rel="noopener noreferrer">
                <div className="doc-icon">
                  <IconDocument />
                </div>
                <div className="doc-text">
                  <h3>Conflict of Interest Policy</h3>
                  <p>Ensuring ethical decisions</p>
                </div>
                <div className="doc-arrow" aria-hidden="true">→</div>
              </a>
              <a href="/docs/Donor-Privacy-Policy.pdf" className="doc-card animated" style={{ '--delay': '.4s' }} target="_blank" rel="noopener noreferrer">
                <div className="doc-icon">
                  <IconDocument />
                </div>
                <div className="doc-text">
                  <h3>Donor Privacy Policy</h3>
                  <p>Our commitment to your data</p>
                </div>
                <div className="doc-arrow" aria-hidden="true">→</div>
              </a>
              <a href="/docs/Gift-Acceptance-Policy.pdf" className="doc-card animated" style={{ '--delay': '.5s' }} target="_blank" rel="noopener noreferrer">
                <div className="doc-icon">
                  <IconDocument />
                </div>
                <div className="doc-text">
                  <h3>Gift Acceptance Policy</h3>
                  <p>Standards for incoming donations</p>
                </div>
                <div className="doc-arrow" aria-hidden="true">→</div>
              </a>
              <a href="/docs/Whistleblower-Policy.pdf" className="doc-card animated" style={{ '--delay': '.6s' }} target="_blank" rel="noopener noreferrer">
                <div className="doc-icon">
                  <IconDocument />
                </div>
                <div className="doc-text">
                  <h3>Whistleblower Policy</h3>
                  <p>Protected reporting channels</p>
                </div>
                <div className="doc-arrow" aria-hidden="true">→</div>
              </a>
              <div className="doc-card disabled animated" style={{ '--delay': '.7s' }} aria-disabled="true">
                <div className="doc-icon">
                  <IconDocument />
                </div>
                <div className="doc-text">
                  <h3>2025 Annual Report</h3>
                  <p>Coming Early 2026</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section" id="verify" aria-labelledby="verify-title">
          <div className="wrap center animated">
            <h2 id="verify-title">Verify Our Status</h2>
            <p className="lede" style={{ fontSize: '1.15rem', marginBottom: '2.0rem' }}>
              Trust, but verify. Use these official resources to confirm our 501(c)(3) status and view our public profile.
            </p>
            <div className="verification-buttons">
              <a
                href="https://apps.irs.gov/app/eos/"
                className="verify-btn irs"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Open IRS Tax Exempt Organization Search in a new tab"
              >
                🛡️ IRS Tax Exempt Organization Search
              </a>
              <a
                href="https://app.candid.org/profile/16361592/cause-and-impact-inc-33-4823180"
                className="verify-btn candid"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Open Candid nonprofit profile in a new tab"
              >
                🧭 View Our Candid Profile
              </a>
            </div>
            <p className="contact-email">
              Registered Address: 841 Virginia Parkway
              <br />
              STR 103 #153
              <br />
              McKinney, TX 75071 • Records requests:{' '}
              <a href="mailto:info@causeandimpact.org">info@causeandimpact.org</a>
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Transparency;